// @ts-nocheck
import React, { useEffect, useMemo, useRef, useState } from 'react';
import { useIntl } from 'react-intl';
import { useReportingMap } from 'sonata-platform-components';
import {
  CartographySettings,
  Map as MapComponent
} from 'sonata-platform-components/lib/types/types/reportingMap.types';
import { SwitchButtonGroup } from 'sonata-react-components';

import { CartographyFilter } from './CartographyFilter';
import { MapTypeSwitch } from './MapTypeSwitch';
import { MapInnerControlsStyle } from './mapInnerControls.style';

type Props = {
  campaignsCountries: string[];
  className?: string;
  isFootfallAttrMap?: boolean;
  mapId: MapComponent['id'];
  supportedCartographyCountries: string[];
};

type State = {
  selectedOption: string | null;
};

function MapInnerControls({
  campaignsCountries,
  className,
  isFootfallAttrMap = false,
  mapId,
  supportedCartographyCountries
}: Props) {
  const { formatMessage } = useIntl();
  const switchButtonRef = useRef(null);

  const { getMap } = useReportingMap();
  const map = getMap({ id: mapId });
  const { settings, type } = map!;
  const currentSettings = settings[type];

  const [{ selectedOption }, setState] = useState<State>({
    selectedOption: null
  });

  const onChangeItemSelected = (item: string | null) => {
    setState(prevState => ({
      ...prevState,
      selectedOption: item
    }));
  };

  const cartographyFilterDisabled =
    type === 'stores' ||
    campaignsCountries.some(country => !supportedCartographyCountries.map(i => i.toUpperCase()).includes(country)) ||
    (type === 'cartography' && (currentSettings as CartographySettings).countries.length > 1);

  const controls: React.ComponentProps<typeof SwitchButtonGroup>['items'] = useMemo(() => {
    const mapControls: React.ComponentProps<typeof SwitchButtonGroup>['items'] = [
      {
        componentData: {
          // @ts-ignore
          Component: MapTypeSwitch,
          componentProps: {
            mapId,
            supportedCartographyCountries
          },
          title: formatMessage({
            defaultMessage: 'Map view',
            id: 'reporting.map.innerControls.mapTypeSwitch.title'
          })
        },
        icon: 'far fa-cog',
        id: 'mapTypeSwitch'
      }
    ];
    mapControls.push({
      componentData: {
        // @ts-ignore
        Component: CartographyFilter,
        componentProps: { mapId },
        title: formatMessage({
          defaultMessage: 'Cartography filter',
          id: 'reporting.map.innerControls.cartographyFilter.title'
        })
      },
      disabled: cartographyFilterDisabled,
      icon: 'far fa-filter',
      id: 'cartographyFilter'
    });
    if (isFootfallAttrMap) {
      return mapControls.filter(c => c.id === 'cartographyFilter');
    }
    return mapControls;
  }, [campaignsCountries, cartographyFilterDisabled, mapId, supportedCartographyCountries, type]);

  useEffect(() => {
    if (typeof switchButtonRef?.current !== 'undefined') {
      // @ts-ignore
      switchButtonRef?.current?.close();
    }
  }, [currentSettings]);

  return (
    <MapInnerControlsStyle className={className}>
      <SwitchButtonGroup
        className={`mapInnerControls__${selectedOption}`}
        id={`mapInnerControls_${mapId}`}
        items={controls}
        onChangeItemSelected={onChangeItemSelected}
        ref={switchButtonRef}
      />
    </MapInnerControlsStyle>
  );
}

export default React.memo(MapInnerControls);
